import i18n from '../language/index'


  $.extend({
    //全局蒙层
    myMongoliaOpen:function (parent = document.body) {
      var defaults = {
        title:i18n.t('base_loading_1658'),
      };

      //创建一个蒙层
      var Mongolia = document.createElement('div');
      Mongolia.classList.add('my-myMongolia');
      parent.appendChild(Mongolia);

      //创建一个小点的框
      var boxFrame = document.createElement('div');
      boxFrame.classList.add('my-boxFrame');
      Mongolia.appendChild(boxFrame);


      //创建小点
      var box = document.createElement('div');
      box.classList.add('my-myMongolia-box');
      boxFrame.appendChild(box);

      //创建小点
      for( var i = 0; i<8; i++){
        var Point = document.createElement('p');
        box.appendChild(Point);
      }

      //创建文字提示
      var title = document.createElement('span');
      title.innerHTML = defaults.title;
      boxFrame.appendChild(title);

    },
    myMongoliaClose:function () {
      var ele = $('.my-myMongolia');
      if(ele.length > 0){
        $('.my-myMongolia').remove();
      }

    }
  })




// WEBPACK FOOTER //
// ./src/base/loading.js